module.exports = __webpack_public_path__ + "img/hero-card.a0a7feeb.png";